import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import request from '../../service/request';
import image from "../../rels_assets/images/blog/b-10.jpg";
import { Helmet } from 'react-helmet';

const scrollToTop = () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth",
	});
};

function Achievement() {
	const customLocation = useLocation();
	const [pageData, setPageData] = useState([]);
	const [menu, setMenu] = useState([]);
	const [pageNotExist, setPageNotExist] = useState(false);
	const [bannerImage, setBannerImage] = useState("");
	const pageslug = 'achievements';

	useEffect(() => {
		scrollToTop();
		getPageData();
	}, []);

	const getPageData = () => {
		request({
			method: 'post',
			url: 'pages/get-page-by-slug',
			headers: { "Content-Type": "application/json", "Accept": "application/json" },
			data: { 'slug': pageslug }
		})
			.then((response) => {
				setPageData(response.data);
			})
			.catch(({ data }) => {
				setPageNotExist(true);
			});
	}

	useEffect(() => {
		request({
			method: 'get',
			url: '/get-menu',
			headers: { "Content-Type": "application/json", "Accept": "application/json" },
		})
			.then((response) => {
				setMenu(response?.data);
			})
			.catch(({ data }) => ({ error: data }));
	}, []);

	useEffect(() => {
		setBannerImage((pageData?.data?.banner_image) ? pageData?.data?.banner_image : '')
	}, [pageData]);

	return (
		<>
			<div>
					<Helmet
						bodyAttributes={{
							class: ((customLocation.pathname == "/")) ? 'homepage-9 hp-6 homepage-11 mh' : 'inner-pages homepage-4 homepage-1 agents hp-6 full hd-white about'
						}}>
						<title>{(pageData && pageData?.data && Object.keys(pageData?.data).length > 0) ? `${menu.data?.site_setting?.site_name} - ${pageData?.data.meta_title}` : "Achievements"}</title>
						<meta name="description" content={pageData && pageData?.data && Object.keys(pageData?.data).length > 0 && pageData?.data.meta_description} />
						{
							pageData?.data &&
							<script type="application/ld+json">
								{JSON.stringify({
									"@context": "https://schema.org/",
									"@type": "Website",
									"name": pageData?.data.meta_title,
									"description": pageData?.data.meta_description,
								})}
							</script>
						}
					</Helmet>
			</div>
			<main id="main" style={{ background: `transparent` }}>
				<section className="small-space ">
					<div className="container">
						<h1 className='text-right' style={{
							backgroundImage: `url('${bannerImage}')`,
							backgroundImage: `-webkit-image-set(url('${bannerImage}') 1x, url('${bannerImage}') 2x)`,
							backgroundImage: `image-set(url('${bannerImage}') 1x, url('${bannerImage}') 2x)`,
							backgroundSize: "contain, cover",
							backgroundRepeat: "no-repeat",
							backgroundPosition: "left center", height: "35vh", padding: "7rem 0", margin: "2rem 0",
							fontSize: "26px",
						}}>Achievements</h1>
						<div className="content-wrapper space-large">
							<div className="row">
								<div className='col-12'>
									{/* <h1 className="title1 custom-pages-title my-5"><strong>Achievements</strong></h1> */}
								</div>
								{
									pageData?.data?.page_description &&
									<div className="col-12" dangerouslySetInnerHTML={{ __html: pageData?.data?.page_description }} >
									</div>
								}
							</div>
						</div>
					</div>
				</section>
			</main>

		</>
	)
}

export default Achievement;